module.exports = __webpack_public_path__ + "static/media/msg-forbidden.41d0bb84.svg";